<p-toast></p-toast>
<div class="workflow-container">
  <div class="workflow-content">
    <div *ngIf="isLoading" class="loadingOverlay center-loader">
      <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
      </p-progressSpinner>
    </div>
    <div class="stages-container">

      <div class="filter-tabs-container">
        <div class="filter-tabs">
          <ng-container *ngIf="selectedUsersList.length === 0">
            <div class="filter-tab" [ngClass]="{'active': selectedMenuID === 'allCandidates'}"
              (click)="openSideMenu('allCandidates')">
              All Candidates
              <span class="candidate-count" *ngIf="selectedMenuID === 'allCandidates'">{{ totalLength }}</span>
            </div>
            <div class="filter-tab" [ngClass]="{'active': selectedMenuID === 'lobby'}" (click)="openSideMenu('lobby')">
              <em class="pi pi-clock tab-icon"></em>
              Lobby
              <span class="candidate-count" *ngIf="selectedMenuID === 'lobby'">{{ totalLength }}</span>
            </div>
            <div class="filter-tab" [ngClass]="{'active': selectedMenuID === 'ongoing'}"
              (click)="openSideMenu('ongoing')">
              <em class="pi pi-play-circle tab-icon"></em>
              Ongoing
              <span class="candidate-count" *ngIf="selectedMenuID === 'ongoing'">{{ totalLength }}</span>
            </div>
            <div class="filter-tab" [ngClass]="{'active': selectedMenuID === 'completed'}"
              (click)="openSideMenu('completed')">
              <em class="pi pi-check-circle tab-icon"></em>
              Completed
              <span class="candidate-count" *ngIf="selectedMenuID === 'completed'">{{ totalLength }}</span>
            </div>
            <div class="filter-tab" [ngClass]="{'active': selectedMenuID === 'cancelled'}"
              (click)="openSideMenu('cancelled')">
              <em class="pi pi-times-circle tab-icon"></em>
              Cancelled
              <span class="candidate-count" *ngIf="selectedMenuID === 'cancelled'">{{ totalLength }}</span>
            </div>
          </ng-container>

          <div class="selection-actions-row" *ngIf="selectedUsersList.length > 0 && (selectedMenuID === 'allCandidates' || selectedMenuID === 'lobby') && !loadingSpinner">
            <span class="selected-count-label">{{ selectedUsersList.length }} Selected</span>
            <button pButton class="action-btn" *ngIf="userPrivileges.has('event_interview.update') && selectedUsersList.length === 1"
              (click)="openEditDialog(selectedUsersList[0])"
              [disabled]="isInterviewActionDisabled(selectedUsersList[0])"
              [pTooltip]="isInterviewActionDisabled(selectedUsersList[0]) ? 'Action not allowed for completed or cancelled interviews' : ''"
              tooltipPosition="top">
              Edit Interview
            </button>
            <button pButton class="action-btn" *ngIf="userPrivileges.has('event_interview.delete') && selectedUsersList.length === 1"
              (click)="openDeleteConfirmDialog(selectedUsersList[0])"
              [disabled]="isInterviewActionDisabled(selectedUsersList[0])"
              [pTooltip]="isInterviewActionDisabled(selectedUsersList[0]) ? 'Action not allowed for completed or cancelled interviews' : ''"
              tooltipPosition="top">
              Cancel Interview
            </button>
          </div>
        </div>

        <div class="search-container-inline" *ngIf="selectedUsersList.length === 0">
          <em class="pi pi-search search-icon"></em>
          <input class="search-input-inline" [(ngModel)]="searchEmailList" (ngModelChange)="onSearchChange($event)"
            type="text" pInputText placeholder="Search Email" />
        </div>


        <div class="table-controls">
          <button pButton class="control-btn"
            pTooltip="Filter" tooltipPosition="top" (click)="showFilterSidebar = true; showSettingsSidebar = false; showDownloadSidebar = false;">
            <img src="assets/icons-svg/filter.svg" alt="Filter" />
            <span *ngIf="getActiveFilterCounts" class="count-badge">
              {{getActiveFilterCounts}}
            </span>
          </button>
          <button pButton class="control-btn" pTooltip="Column Settings" tooltipPosition="top" (click)="onColumnPreferenceClick()">
            <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
          </button>
          <button pButton class="control-btn" pTooltip="Download" tooltipPosition="top" (click)="showDownloadSidebar = true; showSettingsSidebar = false;">
            <img src="assets/icons-svg/download.svg" alt="Download" />
          </button>
          <button pButton class="control-btn" *ngIf="selectedMenuID === 'completed' && totalLength > 0 && userPrivileges.has('event_interview_candidate.export')"
            pTooltip="Download All Insights" tooltipPosition="top" (click)="downloadAllInsights()"
            [disabled]="insightsExportLoading">
            <i class="pi pi-file-excel control-btn-icon"></i>
          </button>
          <button pButton class="control-btn" pTooltip="Refresh" tooltipPosition="top" (click)="tableRefresh()">
            <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
          </button>
          <span class="table-menu">
            <p-select class="view-list-dropdown" [options]="pageLimits" [(ngModel)]="pageSize"
              (onChange)="getUsersByLimit()" [disabled]="loadingSpinner">
            </p-select>
            <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner"
              class="p-button-secondary p-button-text simple-btn">
              <i class="pi pi-angle-left"></i>
            </button>
            <button pButton class="disabled p-button-secondary p-button-text simple-btn">
              {{ loadingSpinner ? '...' : (pageNumber + ' of ' + totalPages) }}
            </button>
            <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner"
              class="p-button-secondary p-button-text simple-btn">
              <i class="pi pi-angle-right"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="table" [style]="{display: 'flex', background: '#F5F5F5'}">

        <p-drawer styleClass="settingsSidebar interview-filter" [transitionOptions]="'300ms'" [(visible)]="showFilterSidebar" [modal]="false"
          position="right" [showCloseIcon]="false" [baseZIndex]="1000" (onShow)="onFilterSidebarShow()">

          <div class="settings-sidebar-header">
            <h3 class="settings-sidebar-title">Stage Filter</h3>
          </div>
          <div class="settings-sidebar-center">
            <div class="settings-content-container">

              <div class="settings-columns-section">
                <div class="filter-column-item" *ngFor="let option of stageFilterOptions">
                  <div class="column-item-left">
                    <input type="radio" [value]="option.value" [(ngModel)]="selectedStageId"
                      [id]="'stage-' + option.value" name="stageFilter" class="stage-radio-input">
                    <label [for]="'stage-' + option.value" class="settings-column-label stage-radio-label">
                      <span class="custom-radio"></span>
                      {{option.label}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="settings-actions">
            <button pButton class="settings-cancel-btn" [outlined]="true" label="Cancel"
              (click)="selectedStageId = appliedStageId; showFilterSidebar = false">
            </button>
            <button pButton class="settings-cancel-btn" [outlined]="true" label="Clear" (click)="clearFilters();">
            </button>
            <button pButton class="settings-apply-btn" label="Apply"
              (click)="onStageFilterChange(selectedStageId); showFilterSidebar = false;">
            </button>
          </div>
        </p-drawer>


        <p-drawer styleClass="settingsSidebar" [transitionOptions]="'300ms'" [(visible)]="showSettingsSidebar"
          [modal]="false" position="right" [showCloseIcon]="false" [baseZIndex]="1000" (onShow)="updatedSelectedColFields()">

          <div class="settings-sidebar-header">
            <h3 class="settings-sidebar-title">Column Settings</h3>
          </div>
          <div class="settings-sidebar-center">
            <div class="settings-content-container">

              <div class="settings-search-container">
                <i class="pi pi-search"></i>
                <input type="text" class="settings-search-input" placeholder="Search" [(ngModel)]="columnSearchTerm"
                  (ngModelChange)="searchColumns($event)" />
              </div>

              <div class="saved-columns-section" *ngIf="savedColumnSettings && savedColumnSettings.length > 0">
                <div class="saved-columns-header">Saved Columns</div>
                <div class="saved-column-item" *ngFor="let column of savedColumnSettings"
                  (click)="applySavedSettings(column.saved_columns)">
                  <span class="saved-column-name">{{column.name}}</span>
                  <i class="pi pi-trash saved-column-delete"
                    (click)="$event.stopPropagation(); deleteSavedColumns(column.id)"></i>
                </div>
              </div>


              <div class="settings-columns-section">
                <div class="settings-column-item" *ngFor="let col of _usersCol">
                  <div class="column-item-left">
                    <p-checkbox 
                      [disabled]="col.index == 1 || col.index == 2" 
                      name="category"
                      [value]="col.field"
                      [ngModel]="checkedColumnsFields"
                      (ngModelChange)="updateCheckedColumns($event)"
                      [inputId]="col.field">
                    </p-checkbox>
                    <label [for]="col.field" class="settings-column-label">{{col.header}}</label>
                  </div>
                  <i class="fas fa-grip-vertical drag-handle"></i>
                </div>
              </div>


              <div class="save-settings-section" *ngIf="!displaySaveColumnSettings">
                <div class="save-settings-toggle" (click)="showSaveColumnSettings()">
                  Save Selected Columns
                </div>
              </div>


              <div class="save-settings-section" *ngIf="displaySaveColumnSettings">
                <form class="save-settings-form" [formGroup]="columnSettings" (ngSubmit)="saveColumnSettings()">
                  <input type="text" class="save-settings-input" placeholder="Enter Column Set Name"
                    formControlName="name">
                  <button type="submit" pButton class="save-settings-btn" label="Save"
                    [disabled]="loadingSpinner"></button>
                  <button type="button" pButton class="p-button-text" (click)="clearColumnPreferenceName()">
                    <i class="pi pi-times"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>


          <div class="settings-actions">
            <button pButton class="settings-cancel-btn" [outlined]="true" label="Cancel" (click)="showSettingsSidebar = false; resetCheckedColumnsToDefault();clearColumnPreferenceName()">
            </button>
            <button pButton class="settings-apply-btn" label="Apply" (click)="applySelectedColumns()">
            </button>
          </div>
        </p-drawer>


        <p-drawer styleClass="downloadSidebar candidateListDownload" [transitionOptions]="'300ms'"
          [(visible)]="showDownloadSidebar" [modal]="false" position="right" [showCloseIcon]="false"
          [baseZIndex]="1000">


          <div class="download-sidebar-header">
            <div class="header-top-row">
              <h3 class="download-sidebar-title">Download Interview Data</h3>
              <div class="format-toggle">
                <div class="format-option">
                  <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
                    <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
                  </div>
                  <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
                </div>
                <div class="format-option">
                  <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}"
                    (click)="downloadAs = 'excel'">
                    <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
                  </div>
                  <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
                </div>
              </div>
            </div>
          </div>


          <div class="download-sidebar-content">
            <div class="download-columns-section">
              <div class="download-column-item select-all-item">
                <p-checkbox [(ngModel)]="selectAllColumns" (onChange)="toggleSelectAll()" [binary]="true"
                  inputId="selectAll">
                </p-checkbox>
                <label for="selectAll" class="download-column-label">Select All</label>
              </div>


              <div class="download-column-item" *ngFor="let col of colsToDownload">
                <p-checkbox name="downloadColumns" [value]="col" [(ngModel)]="checkedColumns" [inputId]="col.field" (onChange)="onColumnCheckChange()">
                </p-checkbox>
                <label [for]="col.field" class="download-column-label">{{col.header}}</label>
              </div>
            </div>
          </div>


          <div class="download-actions">
            <div class="download-buttons-row">
              <button pButton class="cancel-btn" label="Cancel" (click)="showDownloadSidebar = false; resetCheckedColumnsToDefault()">
              </button>
              <button pButton class="download-btn" label="Download" [disabled]="checkedColumns.length === 0"
                (click)="(downloadAs === 'excel') ? exportCandidate('excel') : exportCandidate('csv')">
              </button>
            </div>
          </div>
        </p-drawer>


        <p-drawer [transitionOptions]="'0ms'" [(visible)]="displayUserDetails"
          styleClass="p-drawer-lg candidateDetaile" position="right" [style]="{width: '650px'}">
          <app-candidate-info [selectedUser]="selectedUser" [numberOfStages]="0" [disableStage]="true"
            [disableFeedback]="false" [disableActivity]="false"></app-candidate-info>
        </p-drawer>


        <p-dialog 
          [(visible)]="feedbackSlider"
          [modal]="true"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{ width: '1050px', maxHeight: '90vh' }"
          [baseZIndex]="10000"
          styleClass="feedback-dialog"
          (onHide)="onFeedbackDialogHide()">
          
          <ng-template pTemplate="header">
            <div class="feedback-dialog-header">
              <h2 class="dialog-title">Feedback</h2>
              <button *ngIf="feedbackMode === 'view' || feedbackMode === 'edit'" pButton
                type="button" class="download-feedback-header-btn" label="Download Feedback"
                (click)="$event.stopPropagation(); feedbackForm.downloadFeedback()">
              </button>
            </div>
          </ng-template>

          <div class="feedback-dialog-body"
            [class.has-panel]="!dialogLoading && (panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create'))">
            
            <div *ngIf="dialogLoading" class="dialog-loading-overlay">
              <p-progressSpinner [style]="{height: '40px', width: '40px'}" strokeWidth="6" animationDuration="0.5s">
              </p-progressSpinner>
            </div>

            <div class="panel-members-sidebar" [style.display]="dialogLoading ? 'none' : ''"
              *ngIf="panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create')">
              <div class="panel-members-title">PANEL MEMBERS ({{panelMembers.length}})</div>
              <div class="panel-member-item" *ngFor="let member of panelMembers"
                [class.active]="selectedPanelMemberId === member.submitted_by_id" (click)="selectPanelMember(member)">
                <div class="panel-member-avatar" [style.background-color]="getAvatarColor(member.submitted_by_name)">
                  {{ getInitials(member.submitted_by_name) }}
                </div>
                <div class="panel-member-info">
                  <span class="panel-member-name">
                    {{ member.submitted_by_name }}
                    <span class="you-tag" *ngIf="member.submitted_by_id === userDetails?.id">(You)</span>
                  </span>
                  <span class="panel-member-date" *ngIf="member.isVirtual" style="color: #ef4444;">
                    Not Submitted
                  </span>
                  <span class="panel-member-date" *ngIf="!member.isVirtual">
                    <i class="pi pi-check-circle" style="color: #22c55e; font-size: 11px;"></i>
                    {{ member.submitted_date | date: 'dd-MM-yyyy hh:mm a' }}
                  </span>
                </div>
                <i class="pi pi-chevron-right panel-member-arrow"></i>
              </div>
            </div>
            <div class="feedback-form-content" [style.display]="dialogLoading ? 'none' : ''">
              <app-feedback-form #feedbackForm [headerData]="paramItems" [candidateDetails]="candidateDetails"
                [feedbackMode]="feedbackMode" (closeFeedbackSlider)="onCloseFeedbackSlider($event)"
                [formUuid]="formUuid" (panelMembersLoaded)="onPanelMembersLoaded($event)"
                (isLoadingFeedback)="onFeedbackLoadingChange($event)">
              </app-feedback-form>
            </div>
          </div>
        </p-dialog>


        <div class="main-table-container">
          <p-table #dt class="modern-table" [columns]="_selectedColumns"
            [value]="loadingSpinner ? skeletonData : candidateList" [loading]="false" [scrollable]="true"
            scrollHeight="76vh" scrollDirection="both" responsiveLayout="scroll" [resizableColumns]="true"
            [rows]="pageSize" dataKey="interview_uuid" [exportFilename]="exportName"
            [globalFilterFields]="['userName', 'status', 'stage', 'email']" [(selection)]="selectedUsersList"
            [style]="{width: '100%'}" (selectionChange)="handleSelection($event)">

            <ng-template pTemplate="header" let-columns>
              <tr class="modern-table-header"
                [ngClass]="{'moveTable': showSettingsSidebar || showDownloadSidebar || showFilterSidebar}">
                <th pFrozenColumn scope="col" class="checkbox-column">
                  <p-tableHeaderCheckbox *ngIf="candidateList.length" [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
                </th>
                <th scope="col" class="candidate-name-column sortable-header" pFrozenColumn pResizableColumn
                  pSortableColumn="name">
                  CANDIDATE NAME
                  <p-sortIcon class="sort-icon" field="name"></p-sortIcon>
                </th>
                <th *ngFor="let user of columns" pResizableColumn scope="col" class="sortable-header"
                  pSortableColumn="{{ user.field }}">
                  {{ user.header }}
                  <p-sortIcon class="sort-icon" field="{{ user.field }}"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user let-columns="columns">
              <tr class="modern-table-row" [ngClass]="{'skeleton-row': loadingSpinner}"
                [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
                <td class="checkbox-column" pFrozenColumn>
                  <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                    <p-tableCheckbox [value]="user"></p-tableCheckbox>
                  </ng-container>
                  <ng-template #skeletonCheckbox>
                    <div class="skeleton skeleton-checkbox"></div>
                  </ng-template>
                </td>

                <td (click)="!loadingSpinner && showCandidateDetails(user, {field: 'name'})"
                  class="candidate-name-column" pFrozenColumn>
                  <ng-container *ngIf="!loadingSpinner; else skeletonText">
                    <div class="candidate-info">
                      <div class="candidate-avatar" [style.background-color]="getAvatarColor(user.name)">

                        <img *ngIf="hasValidPhoto(user)" [src]="user.photo" [alt]="user.name" class="candidate-photo"
                          (error)="onImageError($event, user)" (load)="onImageLoad($event)" />

                        <span class="candidate-initials" [style.display]="hasValidPhoto(user) ? 'none' : 'flex'">
                          {{ getInitials(user.name) }}
                        </span>
                      </div>
                      <div class="candidate-details">
                        <span class="candidate-name">{{ user.name }}</span>
                        <span class="candidate-id"
                              (click)="$event.stopPropagation(); copyToClipboard(user.candidate_uuid || user.userId, 'Candidate ID')"
                              (keydown.enter)="copyToClipboard(user.candidate_uuid || user.userId, 'Candidate ID')"
                              (keydown.space)="copyToClipboard(user.candidate_uuid || user.userId, 'Candidate ID')"
                              title="Click to copy Candidate ID"
                              role="button"
                              tabindex="0"
                              [attr.aria-label]="'Candidate ID: ' + getTruncatedId(user.candidate_uuid || user.userId) + '. Click to copy to clipboard'">
                          {{ getTruncatedId(user.candidate_uuid || user.userId) }}
                        </span>
                      </div>
                      
                    </div>
                  </ng-container>
                  <ng-template #skeletonText>
                    <div class="skeleton skeleton-text skeleton-text-long"></div>
                  </ng-template>
                </td>

                <td *ngFor="let col of columns" (click)="!loadingSpinner && showCandidateDetails(user, col)"
                  [ngClass]="{'candidate-name-cell': col.field === 'name'}">
                  <ng-container *ngIf="!loadingSpinner; else skeletonCell">
                    <span [ngSwitch]="true">
                      <span *ngSwitchCase="col.field === 'action' && selectedMenuID !== 'completed' ">
                        <span *ngIf="user.interview_mode === 'AI'">-</span>
                        <button *ngIf="user.interview_mode !== 'AI' && userPrivileges.has('event_interview.join') && user.interview_mode !== 'Offline' && !isAIInterviewStage(user)"
                          pButton class="joinBtn" (click)="openJitsiContainer(user)" label="Join Interview"></button>
                        <button *ngIf="user.interview_mode !== 'AI' && userPrivileges.has('event_interview.join') && user.interview_mode === 'Offline'"
                          pButton class="joinBtn" (click)="offlineInterviewJoin(user)" label="Start Interview"></button>
                      </span>
                      <span *ngSwitchCase="col.field === 'insights'">
                        <div class="recording-actions">
                          <button *ngIf="user.status === 'Completed' && ((user.provider === 'default' && user.interview_recording_url) || user.provider !== 'default')"
                            pButton class="joinBtn" pTooltip="View Insights"
                            (click)="viewRecordedVideo(user)" label="View">
                          </button>
                          <span *ngIf="user.status !== 'Completed' || (user.provider === 'default' && !user.interview_recording_url)">-</span>
                        </div>
                      </span>
                      <span *ngSwitchCase="col.field === 'action' && selectedMenuID === 'completed'">
                        <div class="recording-actions">
                          <button type="button" *ngIf="(user.provider === 'default' && user.interview_recording_url) || user.provider !== 'default'" pButton class="joinBtn" pTooltip="View Insights"
                            (click)="viewRecordedVideo(user)" label="View">
                          </button>

                          <span *ngIf="user.provider === 'default' && !user.interview_recording_url">-</span>
                        </div>
                      </span>
                      <span *ngSwitchCase="col.field === 'recording'">
                        <div class="recording-actions">
                          <button *ngIf="user.interview_recording_url" pButton class="joinBtn" pTooltip="View Recording"
                            (click)="openRecording(user)" label="View">
                          </button>

                          <span *ngIf="!user.interview_recording_url">No Recording</span>
                        </div>
                      </span>
                      <span *ngSwitchCase="col.field === 'status'">
                        <span [ngSwitch]="user[col.field]">
                          <span *ngSwitchCase="'InMeeting'" class="modern-status-badge status-in-meeting">Live</span>
                          <span *ngSwitchCase="'meetingEnd'"
                            class="modern-status-badge status-completed">Completed</span>
                          <span *ngSwitchDefault class="modern-status-badge"
                            [ngClass]="'status-' + user[col.field]?.toLowerCase()?.split(' ')?.join('-')">{{user[col.field]
                            ? user[col.field] : '-'}}</span>
                        </span>
                      </span>
                      <span *ngSwitchCase="col.field === 'isFeedbackSubmitted'" class="feedBackCell">
                        <span *ngIf="user.interview_mode === 'AI'">-</span>
                        <button *ngIf="user.interview_mode !== 'AI' && user[col.field]" class="feedback-action-btn"
                          (click)="$event.stopPropagation(); openPanelMemberView(user)" pTooltip="View Panel Feedback"
                          tooltipPosition="top">
                          View
                        </button>
                        <button
                          *ngIf="user.interview_mode !== 'AI' && ((selectedMenuID === 'completed' || selectedMenuID === 'lobby' || selectedMenuID === 'ongoing') || (selectedMenuID === 'allCandidates' && user.status === 'Completed')) && !user[col.field] && userPrivileges.has('event_interview.submit_feedback_form')"
                          class="feedback-action-btn" (click)="$event.stopPropagation(); openPanelMemberView(user)"
                          pTooltip="Submit Feedback" tooltipPosition="top">
                          Submit
                        </button>
                        <span
                          *ngIf="user.interview_mode !== 'AI' && !user[col.field] && (!userPrivileges.has('event_interview.submit_feedback_form') || !((selectedMenuID === 'completed' || selectedMenuID === 'lobby' || selectedMenuID === 'ongoing') || (selectedMenuID === 'allCandidates' && user.status === 'Completed')))">
                          -
                        </span>
                      </span>
                      <span *ngSwitchCase="col.field === 'submittedCode'">
                        <button *ngIf="user[col.field]; else noCode" pButton class="joinBtn"
                          (click)="openViewCode(user)" label="</>" pTooltip="View Code"></button>
                        <ng-template #noCode>Not Submitted</ng-template>
                      </span>
                      <span *ngSwitchCase="col.field === 'interviewDate'">
                        <span>{{user[col.field]}}</span>
                      </span>
                      <span *ngSwitchCase="col.field === 'interview_location'">
                        <span [pTooltip]="user[col.field]" tooltipPosition="top" class="interview-location"
                          (click)="showLocationPopover($event, user[col.field], locationPanel)">
                          {{user[col.field] ? user[col.field] : '-'}}
                        </span>
                      </span>
                      <span *ngSwitchCase="col.field === 'mins'">
                        <span>{{user[col.field]}}</span>
                      </span>
                      <span *ngSwitchCase="col.field === 'interview_mode'">
                        <span class="modern-status-badge" [ngClass]="user[col.field] === 'Offline' ? 'tag-offline-interview' : user[col.field] === 'AI' ? 'tag-ai-interview' : 'tag-interview'">{{user[col.field]}}</span>
                      </span>
                      <span *ngSwitchCase="col.field === 'recruiterName'">
                        <span class="locations-op" *ngIf="user.interviewerNames && user.interviewerNames.length > 0">
                          <span class="location-name-text">{{ user.interviewerNames[0] }}</span>
                          <div *ngIf="user.interviewerNames.length > 1" class="remainingItems-badge">
                            <p-badge 
                              value="+{{ user.interviewerNames.length - 1 }}" 
                              styleClass="mr-2" 
                              [pTooltip]="getInterviewerTooltip(user.interviewerNames)" 
                              tooltipPosition="top"
                              [escape]="false">
                            </p-badge>
                          </div>
                        </span>
                        <span *ngIf="!user.interviewerNames || user.interviewerNames.length === 0">
                          {{user[col.field] ? user[col.field] : '-'}}
                        </span>
                      </span>
                      <span *ngSwitchDefault>
                        {{user[col.field] ? user[col.field] : '-'}}
                      </span>
                    </span>
                  </ng-container>
                  <ng-template #skeletonCell>
                    <div class="skeleton" [ngClass]="{
                                            'skeleton-badge': col.field === 'status' || col.field === 'action' || col.field === 'insights',
                                            'skeleton-text': col.field !== 'status' && col.field !== 'action' && col.field !== 'isFeedbackSubmitted',
                                            'skeleton-text-short': col.field === 'isFeedbackSubmitted' || col.field === 'mins'
                                        }"></div>
                  </ng-template>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
                  <div class="empty-state">
                    <div class="empty-state-icon">
                      <i class="pi pi-search"></i>
                    </div>
                    <h3 class="empty-state-title">No Candidates Found</h3>
                    <p class="empty-state-description">
                      Try adjusting filters or search terms.
                    </p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <p-drawer 
            model="true" 
            [style]="{width: '55rem'}"
            [(visible)]="recordedVideoSidebarView" 
            styleClass="p-drawer-lg candidateSidebar" 
            [showCloseIcon]="true" 
            position="right">
            
            <div *ngIf="videoLink" class="video-content">
                
                <div class="header-section">
                    <div class="header-title-box">
                    <div class="header-title">
                    <i class="pi pi-video"></i>
                    <h2 >
                        Interview Recording
                    </h2>
                    </div>
                    <div>
                    <p class="header-subtitle" *ngIf="showInterviewAnalysis">
                        Review the candidate's performance and insights
                    </p>
                    </div>
                    </div>
                </div>

                <div *ngIf="displayVideo" class="video-container">
                    <div class="video-wrapper">
                        <iframe
                            *ngIf="videoLink"
                            [src]="videoLink"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                            class="video-iframe"
                            title="Recorded Interview">
                        </iframe>
                    </div>
                </div>


            </div>
        </p-drawer>

        <p-drawer model="true" class="addRole-slider" [style]="{width: '55rem'}" [(visible)]="submittedCodeView"
          styleClass="p-drawer-lg" [showCloseIcon]="true" position="right">
          <div class="sidebar-header">
            <div class="sidebar-heading">Submitted Code</div>
          </div>
          <div class="p-divider p-divider-horizontal p-divider-solid">
            <span class="p-divider-content"></span>
          </div>

          <div class="language">Language: <span style="color: black;">{{codeLang}}</span></div>
          <pre class="code-snippets">
                        <code [innerHTML]="userCode"></code>
                    </pre>
        </p-drawer>
      </div>
    </div>
  </div>
  <p-popover #locationPanel [dismissable]="true" styleClass="no-padding-overlay">
    <div style="max-width: 300px; word-wrap: break-word; white-space: pre-wrap;">
      {{ activeLocation }}
    </div>
  </p-popover>

  <p-dialog [(visible)]="showEditDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    [styleClass]="'sendlink-dialog' + (editingCandidate?.interview_mode === 'AI' ? ' edit-dialog-ai-mode' : '')" [style]="{width: '600px', maxWidth: '95vw'}" (onHide)="closeEditDialog()" class="neo-dialog">

    <div class="dialog-wrapper">
      <div class="dialog-header">
        <h2 class="dialog-title">Edit Interview</h2>
        <button type="button" class="dialog-close-btn" (click)="closeEditDialog()" aria-label="Close">
          <em class="pi pi-times"></em>
        </button>
      </div>

      <div class="dialog-content">
        <div class="content-wrapper">
          <form [formGroup]="editInterviewForm" class="send-email-form">
            <div class="form-row two-columns">
              <div class="form-field neo-input-wrapper">
                <label class="field-label">Date <span class="required-asterisk">*</span></label>
                <p-datepicker 
                  bigger
                  iconDisplay="input"
                  formControlName="interviewDate" 
                  [showIcon]="true" 
                  dateFormat="dd/mm/yy"
                  [ngClass]="{'invalid': editFormClicked && editInterviewForm.controls['interviewDate'].errors}"
                  class="form-calendar"
                  placeholder="Select Date"
                  styleClass="full-width-calendar"
                  (onSelect)="onEditFormChange()">
                </p-datepicker>
              </div>

              <div class="form-field neo-input-wrapper">
                <label class="field-label">Start Time <span class="required-asterisk">*</span></label>
                <p-select 
                  bigger
                  class="form-dropdown"
                  [options]="timeSlots" 
                  formControlName="startTime" 
                  optionLabel="formattedTime"
                  appendTo="body"
                  [ngClass]="{'invalid': editFormClicked && editInterviewForm.controls['startTime'].errors}"
                  placeholder="Select Start Time"
                  (onChange)="onEditFormChange()">
                </p-select>
              </div>
            </div>

            <div class="form-field neo-input-wrapper" *ngIf="editingCandidate && editingCandidate.interview_mode !== 'AI'">
              <label class="field-label">Interviewer(s)</label>
              
              <div class="selected-interviewers-tags" *ngIf="selectedEditInterviewers.length > 0">
                <div class="interviewer-tag" *ngFor="let interviewerId of selectedEditInterviewers">
                  <span class="interviewer-avatar" [style.background-color]="getInterviewerAvatarColorForEdit(interviewerId)">
                    {{getInterviewerInitials(interviewerId)}}
                  </span>
                  <span class="interviewer-tag-name">{{getInterviewerName(interviewerId)}}</span>
                  <button type="button" class="interviewer-tag-remove" (click)="removeEditInterviewer(interviewerId); onEditFormChange()">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>

              <p-multiselect 
                bigger
                class="form-dropdown interviewer-multiselect"
                [options]="interviewerList" 
                [(ngModel)]="selectedEditInterviewers"
                [ngModelOptions]="{standalone: true}"
                optionLabel="label"
                optionValue="value"
                [selectionLimit]="3"
                placeholder="Select Interviewer (Max 3)"
                appendTo="body"
                (onPanelShow)="onInterviewerPanelShow()"
                (onChange)="onEditFormChange()">
              </p-multiselect>
            </div>

            <div class="form-row two-columns">
              <div class="form-field neo-input-wrapper">
                <label class="field-label">Duration <span class="required-asterisk">*</span></label>
                <p-select 
                  bigger
                  class="form-dropdown"
                  [options]="durationSlots" 
                  formControlName="duration"
                  optionLabel="label"
                  appendTo="body"
                  [ngClass]="{'invalid': editFormClicked && editInterviewForm.controls['duration'].errors}"
                  placeholder="Select Duration"
                  (onChange)="onEditFormChange()">
                </p-select>
              </div>

              <div class="form-field neo-input-wrapper">
                <label class="field-label">Job Role <span class="required-asterisk">*</span></label>
                <p-select 
                  bigger
                  class="form-dropdown"
                  [options]="interviewJobRoles" 
                  formControlName="jobRoleId"
                  optionLabel="label"
                  appendTo="body"
                  [ngClass]="{'invalid': editFormClicked && editInterviewForm.controls['jobRoleId'].errors}"
                  placeholder="Select Job Role"
                  (onChange)="onEditFormChange()">
                </p-select>
              </div>
            </div>

            <div class="form-field neo-input-wrapper" *ngIf="editingCandidate?.interview_mode === 'Offline'">
              <label class="field-label">Venue</label>
              <input pInputText type="text" formControlName="venue" class="form-input" placeholder="Enter venue" (input)="onEditFormChange()">
            </div>
          </form>
        </div>
      </div>

      <div class="dialog-footer">
        <button pButton type="button" class="send-invite-btn" label="Update Interview" (click)="updateInterview()" [loading]="editInterviewLoading" [disabled]="!isEditFormDirty"></button>
      </div>
    </div>
  </p-dialog>

  <div class="modal-backdrop" *ngIf="showDeleteConfirmDialog" (click)="closeDeleteConfirmDialog()">
    <div class="modal-container delete-member-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Cancel Interview</h3>
        <button type="button" class="close-btn" (click)="closeDeleteConfirmDialog()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="warning-icon">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <p class="confirmation-text">
          Are you sure want to cancel interview for <strong>{{ deletingCandidate?.name }}</strong>?
        </p>
        <p class="sub-text">This action cannot be undone.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirmDialog()"
          [disabled]="deleteInterviewLoading">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmDeleteInterview()"
          [disabled]="deleteInterviewLoading">
          <span *ngIf="deleteInterviewLoading" class="spinner"></span>
          {{ deleteInterviewLoading ? 'Cancelling...' : 'Cancel Interview' }}
        </button>
      </div>
    </div>
  </div>

</div>